import type { ReactElement } from 'react';

export default function Plus(): ReactElement {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Automated migration to Biome
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.33398 12H16.334'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.334 8V16'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <rect
        x='1.66602'
        y='22.5'
        width='21'
        height='21'
        rx='10.5'
        transform='rotate(-90 1.66602 22.5)'
        stroke='currentColor'
        strokeWidth='2'
      />
    </svg>
  );
}
